import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

// ─── Shared primitives ────────────────────────────────────────────────────────
export function SearchInput({ value, onChange, placeholder, width=240, T }) {
  return (
    <div style={{
      display:'flex', alignItems:'center', gap:8,
      width, flexShrink:0,
      background:T.inputBg, border:`1px solid ${T.border}`,
      borderRadius:8, padding:'7px 12px',
    }}>
      <Search size={13} style={{color:T.textMuted, flexShrink:0}}/>
      <input type="text" placeholder={placeholder} value={value}
        onChange={e=>onChange(e.target.value)}
        style={{flex:1, minWidth:0, background:'transparent', border:'none', outline:'none',
          fontSize:13, color:T.text, fontFamily:'inherit'}}/>
      {value && (
        <button type="button" onClick={()=>onChange('')}
          style={{color:T.textMuted, background:'none', border:'none', cursor:'pointer', padding:0, lineHeight:1}}>
          <X size={12}/>
        </button>
      )}
    </div>
  );
}

export function Chip({ label, active, onClick, T }) {
  return (
    <button type="button" onClick={onClick} style={{
      cursor:'pointer', borderRadius:8,
      border:`1px solid ${active ? 'transparent' : T.chipBorder}`,
      background: active ? 'var(--accent)' : T.chip,
      color: active ? 'var(--accent-fg, #fff)' : T.chipText,
      padding:'5px 12px', fontSize:13, fontWeight:500, fontFamily:'inherit',
    }}>{label}</button>
  );
}

export function AccentBtn({ children, onClick, icon: Icon }) {
  const [hov, setHov] = useState(false);
  return (
    <button type="button" onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{
        display:'inline-flex', alignItems:'center', gap:6, borderRadius:8, padding:'7px 14px',
        background: hov ? 'var(--accent-hover)' : 'var(--accent)',
        color:'var(--accent-fg, #fff)', border:'none', cursor:'pointer', fontSize:13, fontWeight:500, fontFamily:'inherit',
      }}>
      {Icon && <Icon size={14}/>} {children}
    </button>
  );
}

export function OutlineBtn({ children, onClick, icon: Icon, T }) {
  const [hov, setHov] = useState(false);
  return (
    <button type="button" onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{
        display:'inline-flex', alignItems:'center', gap:6, borderRadius:8, padding:'7px 14px',
        background: hov ? T.hover : T.card,
        color:T.textSub, border:`1px solid ${T.chipBorder}`,
        cursor:'pointer', fontSize:13, fontWeight:500, fontFamily:'inherit',
      }}>
      {Icon && <Icon size={14}/>} {children}
    </button>
  );
}

export function IconBtn({ children, onClick, T }) {
  const [hov, setHov] = useState(false);
  return (
    <button type="button" onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{
        display:'inline-flex', alignItems:'center', justifyContent:'center',
        borderRadius:8, padding:7,
        background: hov ? T.hover : T.card,
        color:T.textSub, border:`1px solid ${T.chipBorder}`, cursor:'pointer',
      }}>
      {children}
    </button>
  );
}

export function DropdownItem({ icon: Icon, label, danger, onClick, T }) {
  const [hov, setHov] = useState(false);
  return (
    <button type="button" onClick={onClick}
      onMouseEnter={()=>setHov(true)} onMouseLeave={()=>setHov(false)}
      style={{
        display:'flex', width:'100%', alignItems:'center', gap:10,
        padding:'8px 16px', fontSize:13, cursor:'pointer', border:'none', fontFamily:'inherit',
        background: hov ? (danger ? 'rgba(239,68,68,0.08)' : T.hover) : 'transparent',
        color: danger ? T.red : T.textSub,
      }}>
      <Icon size={13}/> {label}
    </button>
  );
}
